import { createSlice } from '@reduxjs/toolkit';
import { loadingSlice } from 'sg-ui-components';

export const defaultSessionState = {
    ready: false,
    session: {}, //? Expected: {"enabled":true,"expires_in":3600,"token_type":"Bearer","scope":"*"}
    errors: {}, //? Expected: {"error":"rate_limited","message":"Too many requests."}
    expires_in: null,
};

// REDUCERS
// basic actions that affect this object only
const getSessionReducer = (state, action) => {
    const sessionReceived = !!action.payload?.expires_in;
    const notInUse = !!action.payload?.not_in_use;

    return {
        ...state,
        ready: sessionReceived || notInUse,
        session: sessionReceived ? action.payload : {},
        expires_in: sessionReceived ? action.payload?.expires_in : null,
        errors: action.payload?.error ? action.payload : {},
    };
};

const resetReducer = () => {
    return {
        ...defaultSessionState,
    };
};

export const sessionSlice = createSlice({
    name: 'session',
    initialState: defaultSessionState,
    reducers: {
        getSession: getSessionReducer,
        reset: resetReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary
const getSession = async (dispatch) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getSession' }));

    try {
        const response = await fetch('/api/session', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });

        // 1. Check for 404 specifically (Not all jurisdiction have this API route)
        if (response.status === 404) {
            console.log('🟠 Session endpoint not found (404). Falling back.');
            return dispatch(sessionSlice.actions.getSession({ error: 'not_found', not_in_use: true }));
        }

        // 2. Check for other non-OK statuses (500, 403, etc.)
        if (!response.ok) {
            throw new Error(`🔴 Server Error: ${response.status}`);
        }

        // 3. Only parse as JSON if the response is actually OK
        const result = await response.json();
        dispatch(sessionSlice.actions.getSession(result));
    } catch (error) {
        // This catches network failures or JSON parsing errors (like response returned in HTML)
        console.error('🔴 Session endpoint: fetch process failed:', error);
        dispatch(sessionSlice.actions.getSession({ error: 'fetch_error', message: error.message }));
    } finally {
        dispatch(loadingSlice.actions.unsetLoading({ action: 'getSession' }));
    }
};

//actions that get exported to the views
export const sessionActions = (dispatch) => {
    return {
        getSession: () => getSession(dispatch),
        reset: () => dispatch(sessionSlice.actions.reset()),
    };
};
